var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import config from "@/config";
import SplashGame from "@/lib/SplashGame";
import UtilsScale from "@/lib/utils/scale";
import CorePanel from "@/prefabs/core/Panel";
var ENUM_TYPE = {
    INGAME: 0,
    GAMEEND: 1,
};
var PanelInformation = /** @class */ (function (_super) {
    __extends(PanelInformation, _super);
    function PanelInformation(scene, x, y, panelType) {
        var _a;
        var _this = _super.call(this, scene, x, y) || this;
        var i18nHandler = SplashGame.i18nHandler.getInstance();
        var STYLES = (_a = {},
            _a[ENUM_TYPE.INGAME] = {
                levelLabel: {
                    x: -180,
                    y: 0,
                    S: i18nHandler.get("panel.information.level"),
                    color: "#ffffff",
                },
                levelText: {
                    x: -50,
                    y: 0,
                    S: "",
                    color: "#ffffff",
                },
                killCountLabel: {
                    x: 85,
                    y: 0,
                    S: i18nHandler.get("panel.information.kill"),
                    color: "#ffffff",
                },
                killCountText: {
                    x: 155,
                    y: 0,
                    S: "",
                    color: "#ffffff",
                },
            },
            _a[ENUM_TYPE.GAMEEND] = {
                levelLabel: {
                    x: -200,
                    y: 0,
                    S: i18nHandler.get("panel.information.score"),
                    color: "#ffffff",
                },
                levelText: {
                    x: -70,
                    y: 0,
                    S: "",
                    color: "#F9D027",
                },
                killCountLabel: {
                    x: 80,
                    y: 0,
                    S: i18nHandler.get("panel.information.kill"),
                    color: "#ffffff",
                },
                killCountText: {
                    x: 150,
                    y: 0,
                    S: "",
                    color: "#FE6787",
                },
            },
            _a);
        _this.panelType = panelType;
        var levelLabel = new Phaser.GameObjects.Text(scene, STYLES[panelType].levelLabel.x, STYLES[panelType].levelLabel.y, STYLES[panelType].levelLabel.S + ":", {
            align: "left",
            fontFamily: config.graphics.fontFamily,
            color: STYLES[panelType].levelLabel.color,
        });
        levelLabel.setFontSize(UtilsScale.text(levelLabel.text, 32, 6));
        _this.text_left = new Phaser.GameObjects.Text(scene, levelLabel.x + levelLabel.width + 10, STYLES[panelType].levelText.y, STYLES[panelType].levelText.S, {
            align: "left",
            fontSize: "32px",
            fontFamily: config.graphics.fontFamily,
            color: STYLES[panelType].levelText.color,
        });
        var killCountLabel = new Phaser.GameObjects.Text(scene, STYLES[panelType].killCountLabel.x, STYLES[panelType].killCountLabel.y, STYLES[panelType].killCountLabel.S + ":", {
            align: "left",
            fontFamily: config.graphics.fontFamily,
            color: STYLES[panelType].killCountLabel.color,
        });
        killCountLabel.setFontSize(UtilsScale.text(killCountLabel.text, 32, 6));
        _this.text_right = new Phaser.GameObjects.Text(scene, killCountLabel.x + killCountLabel.width + 10, STYLES[panelType].killCountText.y, STYLES[panelType].killCountText.S, {
            align: "left",
            fontSize: "32px",
            fontFamily: config.graphics.fontFamily,
            color: STYLES[panelType].killCountText.color,
        });
        levelLabel.setOrigin(0, 0.5);
        _this.text_left.setOrigin(0, 0.5);
        killCountLabel.setOrigin(0, 0.5);
        _this.text_right.setOrigin(0, 0.5);
        _this.bg = new Phaser.GameObjects.Image(scene, 0, 0, "background.".concat(_this.panelType == ENUM_TYPE.INGAME ? "level-kill" : "score-kill"), 0)
            .setOrigin(0.5)
            .setScale(1.2, 1);
        _this.add(_this.bg);
        _this.add(new Phaser.GameObjects.Image(scene, 0, 0, "icon.seperator").setOrigin(0.5));
        _this.add(new Phaser.GameObjects.Image(scene, levelLabel.x - levelLabel.width / 2, 0, "icon.".concat(_this.panelType == ENUM_TYPE.INGAME ? "level" : "score")).setOrigin(0, 0.5));
        _this.add(new Phaser.GameObjects.Image(scene, killCountLabel.x - killCountLabel.width / 2 - 10, 0, "icon.kill", 0).setOrigin(0, 0.5));
        _this.add(levelLabel);
        _this.add(_this.text_left);
        _this.add(killCountLabel);
        _this.add(_this.text_right);
        _this.setScale(0.75);
        _this.setDepth(9990);
        _this.setScrollFactor(0);
        // RESIZE
        _this.RESIZE_H_FACTOR = 1;
        _this.RESIZE_H_MAX = _this.bg.height;
        _this.RESIZE_W_FACTOR = 0.4;
        _this.RESIZE_W_MAX = _this.bg.width;
        return _this;
    }
    PanelInformation.prototype.setPosition = function (x, y, z, w) {
        var _a;
        _super.prototype.setPosition.call(this, x, y + ((_a = this.bg) === null || _a === void 0 ? void 0 : _a.height), z, w);
        return this;
    };
    PanelInformation.prototype.setValues = function (a, b) {
        this.text_left.text = a + "";
        this.text_right.text = b + "";
    };
    return PanelInformation;
}(CorePanel));
export default PanelInformation;
